import ReactDOM from 'react-dom';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { useOutside } from 'hooks/UseOutside';
import { ModalCloseButton } from '../SetDocumentModal/_setDocumentModal';

import { Container, ModalContainer } from './_productListModal';
import { toast } from 'react-toastify';
import api from 'services/api';
import { getProductNameFromServiceId } from 'utils/getProductNameFromServiceId';

interface IServiceTypeDifficulty {
  id: number;
  name: string;
  default_price: number;
  difficulty: number;

  formattedDefaultPrice: string;
}

export interface IProduct {
  id: number | string;
  category: string;
  type: string;
  brand: string;
  model: string;
  link: string;
  marketplace: string;
  partner: string;
  difficulty: number;
  price: number;
}

interface IProductListModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  difficulty: IServiceTypeDifficulty;
  serviceTypeId: number | string;
}

export const ProductListModal = ({ toggleModal, difficulty, serviceTypeId }: IProductListModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);
  const [products, setProducts] = useState<IProduct[]>([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);
  const loadMoreRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (difficulty) {
      fetchProducts();
    }
  }, [difficulty, currentPage]);

  useEffect(() => {
    if(hideModal) {

    }
  }, [hideModal]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25,
    };

    const observer = new IntersectionObserver((entities) => {
      const target = entities[0];

      if (target.isIntersecting) {
        setCurrentPage((prevState) => {
          if (!isLastPage && products.length) {
            return prevState + 1;
          }
          return prevState;
        })
      }
    }, options);

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [loadMoreRef.current]);

  const fetchProducts = async () => {
    try {
      const response = await api.get<{
        results: IProduct[];
        page: number;
        total: number;
        limit: number;
      }>('/products', {
        params: {
          difficulty: difficulty.difficulty,
          model: '',
          page: currentPage,
          limit: 15,
          category_id: serviceTypeId
        }
      });

      if(response.data.total < response.data.limit) {
        setIsLastPage(true);
      }

      setProducts((prevState) => ([...prevState, ...response.data.results]));

    } catch (error: any) {
      toast.error(error?.response?.data?.message || error?.message);
    }
  }

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      setCurrentPage(1);
      setIsLastPage(false);
      toggleModal((prevState) => !prevState);
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if (!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <Container className={`${hideModal ? 'modal-product-list--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton type="button" onClick={handleCloseModal}>X</ModalCloseButton>
        <h1 className="modal-product-list__title">
          Lista de {
            getProductNameFromServiceId(Number(serviceTypeId))
          } com grau de complexidade: {difficulty.difficulty}
        </h1>

        <div className="modal-product-list__list-wrapper">
          <div className="modal-product-list__list-items-container">
            {
              products.map((product) => (
                <div className="modal-product-list__list-item">
                  <h2>
                    {product.model}
                  </h2>
                  <p>Marca: {product.brand}</p>
                  <p>Tipo: {product.type}</p>
                </div>
              ))
            }
          </div>
          <div
            className="modal-product-list__load-more"
            ref={loadMoreRef}
          />
        </div>
      </ModalContainer>
    </Container>,
    modalRoot
  )
}
